import { DateTime } from 'luxon'

const currentDateTime = DateTime.now()
const nextWeek = currentDateTime.plus({ days: 7 }).toFormat('yyyy-MM-dd')

const state = {
  address: '',
  approved: false,
  campaign_id: undefined,
  creditor_id: undefined,
  created_by: 'creditor',
  creditor_type: '',
  currency_code: '',
  data: {},
  dates: {},
  debtor: {},
  debtor_id: undefined,
  debtor_name: '',
  debtor_type: '',
  due_date: nextWeek,
  id: null,
  notes: '',
  order_id: undefined,
  order_title: '',
  paid: false,
  purchase_order: '',
  reference: '',
  total: undefined,
  void: false,
}

export const requiredFields = []

export default state
